module.exports = __webpack_public_path__ + "static/media/wizualizacja-84.e282f4f9.png";